//import _ from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import styled from 'styled-components';
import { BaseComponent } from '../../../components/BaseComponent';
import { getPropByName } from '../../../utils/props';
import { Check } from '../../../components/Icon';
import { fetchCompanyUsers } from '../actions';
import { Well } from '../../../components/Well';
import { selectWork } from '../../Api/selectors';
import { REQUEST_COMPANY_USERS } from '../constants';
import { Loader } from '../../../components/Loader';
import { Cell, List, Row } from '../../../components/List';
import { COLOR_PRIMARY_1 } from '../../../vars';

const STATE = {};

const Container = styled.div`
  .row.selected {
    background-color: ${COLOR_PRIMARY_1} !important;
    color: white;
  }
`;

/* eslint-disable react/prefer-stateless-function */
class CompanyUserSelectionComp extends BaseComponent {
  constructor(props) {
    super(props, { ...STATE });
  }

  componentDidMount() {
    this.props.getUsers((a, b) => {
      if (!a?.length) return this.setState({ empty: true });
      this.setState({ users: a, empty: false });
    });
  }

  render() {
    if (this.props.loading) return <Loader small />;
    if (this.state.empty) return <Well>{this.lbl('company.user.selection.empty')}</Well>;
    if (!this.state.users) return 'nothing';

    return (
      <Container>
        <List>{this.state.users?.map(this.renderUser.bind(this))}</List>
      </Container>
    );
  }

  renderUser(user) {
    const selected = user.id == this.props.selectedUserId;
    return (
      <Row key={user.id} className={`${selected ? 'selected' : null} user `} onClick={() => this.props.onSelect?.(user)}>
        <Cell>{selected ? <Check /> : null}</Cell>
        <Cell>{getPropByName(user, 'name')}</Cell>
        <Cell>{getPropByName(user, 'surname')}</Cell>
        <Cell>{getPropByName(user, 'email_address')}</Cell>
      </Row>
    );
  }
}

CompanyUserSelectionComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) =>
  createStructuredSelector({
    loading: selectWork(REQUEST_COMPANY_USERS),
  });

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
    getUsers(callback) {
      dispatch(fetchCompanyUsers(ownProps.companyId, callback));
    },
  };
}

const withConnect = connect(
  mapStateToProps,
  mapDispatchToProps,
);

export const CompanyUserSelection = compose(
  withConnect,
  withRouter,
)(CompanyUserSelectionComp);
